// extracted by mini-css-extract-plugin
export var contrastLow = "_d-1";
export var externalLink = "_d-2";
export var externalLinkIcon = "_d-3";
export var link = "_d-0";
export var linkLabel = "_d-4";